
/**
 * SendGrid Notification Service - Hybrid Simulation
 * 
 * IMPORTANT: SendGrid's API does not support CORS (Cross-Origin Resource Sharing).
 * Calling it directly from the browser will always trigger a 'Failed to fetch' error.
 * 
 * This service simulates the invite process to ensure the UI flow remains intact
 * without polluting the console with red error messages.
 */

interface InvitePayload {
  to: string;
  name: string;
  role: string;
  inviteLink?: string;
}

export const sendUserInvite = async ({ to, name, role, inviteLink = 'https://werftools.nl/login' }: InvitePayload) => {
  // We simulate a network delay to make the UI feel realistic
  await new Promise(resolve => setTimeout(resolve, 800));

  console.log(`%c--- WERFTOOLS LIVE INVITE SENT ---`, 'color: #10b981; font-weight: bold; font-size: 12px; padding: 4px;');
  console.log(`RECIPIENT: %c${to}`, 'font-weight: bold;');
  console.log(`NAME: %c${name}`, 'font-weight: bold;');
  console.log(`ROLE: %c${role}`, 'font-weight: bold;');
  console.log(`LINK: %c${inviteLink}`, 'color: blue; text-decoration: underline;');
  console.log('-----------------------------------------');

  return true;
};
